import React from "react"; // eslint-disable-line no-unused-vars
import HeroImage from "../../HeroImage";
import imgHeaderDocumentSearchMobile from "../../assets/img_header_document_search_mobile.jpg";
import imgHeaderDocumentSearch from "../../assets/img_header_document_search.jpg";
import "./styles.css";

const NotListedCountry = () => (
  <div className="page-container">
    <div className="page-content search-margin-bottom">
      <HeroImage
        title="Contact Us"
        imageMobile={imgHeaderDocumentSearchMobile}
        imageDesktop={imgHeaderDocumentSearch}
      />
      <div className="container">
        <br></br>
        <p>Belarus, Kazakhstan, or Russia queries, please call: +7 495 258 42 77 or <a href="https://www.abbvie.ru/contactus.html">click here</a>.</p> 
        <p>For relevant privacy information, please see below:</p>
        <p>Russia: <a href="https://privacy.abbvie/privacy-policies/russia-privacy-policy.html">click here</a>.</p>
        <p>Belarus: <a href="https://privacy.abbvie/privacy-policies/Belarus-privacy-notice.html">click here</a>.</p>
        <p>Kazakhstan: <a href="https://privacy.abbvie/privacy-policies/kazakhstan.html">click here</a>.</p>
        <br></br>

        <p>вопросов из Беларуси, Казахстана или России, пожалуйста, звоните по номеру: +7 495 258 42 77 или <a href="https://www.abbvie.ru/contactus.html">нажмите здесь</a>.</p>
        <p>Актуальная информация о конфиденциальности представлена ниже:</p>
        <p>России: <a href="https://privacy.abbvie/privacy-policies/russia-privacy-policy.html">нажмите здесь</a>.</p>
        <p>Беларуси: <a href="https://privacy.abbvie/privacy-policies/Belarus-privacy-notice.html">нажмите здесь</a>.</p>
        <p>Казахстана: <a href="https://privacy.abbvie/privacy-policies/kazakhstan.html">нажмите здесь</a>.</p>
      </div>
    </div>
  </div>
);
export default NotListedCountry;



// WEBPACK FOOTER //
// ./src/mi-app/Pages/notListedCountries/NotListedCountry.js